import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import DataTable from 'react-data-table-component';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { AddDeleteUpadate, fetchPostData, fetchPostDataNew } from '@/Components/hooks/Api';
import { toastifySuccess } from '@/Components/Common/AlertMsg';
import { ContentState, EditorState } from 'draft-js';
import htmlToDraft from 'html-to-draftjs';
import { RequiredFieldIncident } from '@/Components/Pages/Utility/Personnel/Validation';
import SelectBox from '@/Components/Common/SelectBox';
import { get_Narrative_Type_Drp_Data } from '@/redux/actions/DropDownsData';
import ReactQuill from 'react-quill';
import CurrentIncMasterReport from '@/Components/Pages/Incident/IncidentTab/CurrentIncMasterReport';
import PoliceForceIncident from '@/Components/Pages/Incident/IncidentTab/PoliceForceIncident/PoliceForceIncident';
import PoliceForce from '@/Components/Pages/Arrest/ArrestTab/PoliceForce/PoliceForce';
import RMSCommentEditor, { ROLE_SUPERVISOR } from '@/Components/Common/RMSCommentEditor';
import { get_Report_Approve_Officer_Data } from '@/redux/actions/IncidentAction';
import { changeArrayFormat_WithFilter, getShowingDateText } from '@/Components/Common/Utility';
import { AgencyContext } from '@/Context/Agency';
import useReportPendingApproval from '../Hooks/useReportPendingApproval';
import { calculateNibrsReadinessPercent } from '@/Components/Pages/ReportModule/Utils/report-module-frw-nibrs-required.utils';
import { compareStrings } from "@/CADUtils/functions/common";
const PendingReportReviewModal = (props) => {
  const parseTablePayload = useCallback((raw) => {
    if (raw == null) return {};
    if (typeof raw === 'string') {
      try {
        return JSON.parse(raw);
      } catch (err) {
        return {};
      }
    }
    return raw;
  }, []);

  const getNameCardLabel = useCallback((row) => {
    if (!row || typeof row !== 'object') return 'Unknown Name';

    const firstName = String(row.FirstName || '').trim();
    const middleName = String(row.MiddleName || '').trim();
    const lastName = String(row.LastName || '').trim();
    const fallback = middleName ? `${firstName} ${middleName} ${lastName}` : `${firstName} ${lastName}`;
    return fallback || 'Unknown Name';
  }, []);

  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('ReportReview');
  const dispatch = useDispatch();

  const reportApproveOfficer = useSelector((state) => state.Incident.reportApproveOfficer);
  const narrativeTypeDrpData = useSelector((state) => state.DropDown.narrativeTypeDrpData);
  const localStoreData = useSelector((state) => state.Agency.localStoreData);
  const { GetDataTimeZone, datezone } = useContext(AgencyContext);

  useEffect(() => {
    if (localStoreData?.AgencyID && !datezone) {
      GetDataTimeZone(localStoreData.AgencyID);
    }
  }, [localStoreData?.AgencyID, datezone, GetDataTimeZone]);

  const { editval, narrativeID, incidentID: reviewIncidentID, loginAgencyID, loginPinID, setModelStatus, checkapproveStatus, reportApprovalStatus, get_Data_Que_Report, WrittenForID, useOfForceID, caseID, arrestID } = props;
  const [clickedRow, setClickedRow] = useState(null);
  const [approvalStatus, setApprovalStatus] = useState('Approve');
  const [narrativeData, setnarrativeData] = useState([]);
  const [approvedNarrativeData, setApprovedNarrativeData] = useState([]);
  const [rejectedNarrativeData, setRejectedNarrativeData] = useState([]);
  const [incidentID, setIncidentID] = useState('');
  const [isSaved, setIsSaved] = useState(false);
  const [reportedPinActivity, setreportedPinActivity] = useState(false);
  const [narrativeTypeId, setnarrativeTypeId] = useState(false);
  const [AsOfDate, setAsOfDate] = useState('');
  const [filteredData, setfilteredData] = useState(false);
  const [loginUserGroupList, setLoginUserGroupList] = useState([]);
  const [groupListWithFilter, setGroupListWithFilter] = useState([]);
  const [selectedOption, setSelectedOption] = useState('Individual');
  const [groupList, setGroupList] = useState([]);
  const [isDataReady, setIsDataReady] = useState(false);
  const [printIncReport, setIncMasterReport] = useState(false);
  const [IncReportCount, setIncReportCount] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [IncidentNo, setIncidentNo] = useState('');
  const [multiSelected, setMultiSelected] = useState({ optionSelected: null });
  const [checkWebWorkFlowStatus, setcheckWebWorkFlowStatus] = useState(false);
  const [reviewStatus, setreviewStatus] = useState(false);
  const [approverRequiredCount, setapproverRequiredCount] = useState();
  const [appRequiredCountCurrentStatus, setappRequiredCountCurrentStatus] = useState();
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [triggerUseOfForcePrintCount, setTriggerUseOfForcePrintCount] = useState(0);
  const [triggerArrestPrintCount, setTriggerArrestPrintCount] = useState(0);
  const [reportSummaryCards, setReportSummaryCards] = useState({
    isLoading: false,
    offenses: [],
    names: [],
    properties: [],
    vehicles: [],
    arrests: [],
  });
  const [rmsReviewComments, setRmsReviewComments] = useState([]);
  const [editorState, setEditorState] = useState(
    () => EditorState.createEmpty(),
  );
  const [value, setValue] = useState({
    NameIDNumber: 'Auto Generated', NameTypeID: '', BusinessTypeID: '', SuffixID: '', VerifyID: '', SexID: '',
    IsApprove: true, IsReject: false, Comments: '', CommentsDoc: '', ApprovalComments: '', IsApprovedForward: '',
    WrittenID: '', UserCommentsDoc: '',
    IsReview: '',
  });

  const [errors, setErrors] = useState({
    ReportedByPinError: '', AsOfDateError: '', NarrativeIDError: '', CommentsError: '',
  });
  const parseAllComments = useCallback((rawComments) => {
    if (Array.isArray(rawComments)) return rawComments;
    if (typeof rawComments === 'string' && rawComments.trim()) {
      try {
        const parsed = JSON.parse(rawComments);
        return Array.isArray(parsed) ? parsed : [];
      } catch (err) {
        return [];
      }
    }
    return [];
  }, []);

  const { GetData_ReportWorkLevelCheck, GetData_ReportWorkLevelCheck_UseOfForce, get_Group_List, get_Data_Narrative, GetPersonnelGroupDetails } = useReportPendingApproval({ setcheckWebWorkFlowStatus, setapproverRequiredCount, setGroupList, setnarrativeData, setApprovedNarrativeData, setRejectedNarrativeData, setfilteredData, setLoginUserGroupList, parseAllComments, });

  const reviewCommentUser = useMemo(() => ({
    name: localStoreData?.fullName || localStoreData?.UserName || 'Reviewer',
    role: ROLE_SUPERVISOR,
    badge: String(localStoreData?.PINID || loginPinID || ''),
  }), [localStoreData, loginPinID]);

  const handleRmsCommentSave = useCallback((content, comments) => {
    const latestComments = Array.isArray(comments) ? comments : [];
    setRmsReviewComments(latestComments);
    setValue((prevState) => ({
      ...prevState,
      UserCommentsDoc: content ?? prevState.UserCommentsDoc ?? '',
    }));
  }, []);

  const hasUnresolvedReviewComments = useMemo(() => (
    Array.isArray(rmsReviewComments) &&
    rmsReviewComments.some((comment) => String(comment?.status || '').toLowerCase() !== 'resolved')
  ), [rmsReviewComments]);

  const hasAnyReviewComments = useMemo(() => (
    Array.isArray(rmsReviewComments) && rmsReviewComments.length > 0
  ), [rmsReviewComments]);
  const hasAllResolvedReviewComments = hasAnyReviewComments && !hasUnresolvedReviewComments;
  const generatedNarrativeContent = useMemo(
    () => value?.CommentsDoc || value?.Comments || '',
    [value?.CommentsDoc, value?.Comments],
  );

  const officerNarrativeContent = useMemo(
    () => value?.UserCommentsDoc || value?.Comments || '',
    [value?.UserCommentsDoc, value?.Comments],
  );

  useEffect(() => {
    if (hasUnresolvedReviewComments) {
      setApprovalStatus('Reject');
      setValue((prevState) => ({
        ...prevState,
        IsApprove: false,
        IsReject: true,
        IsApprovedForward: false,
        IsReview: false,
      }));
      return;
    }
    if (hasAllResolvedReviewComments) {
      setApprovalStatus('Approve');
      setValue((prevState) => ({
        ...prevState,
        IsApprove: true,
        IsReject: false,
        IsApprovedForward: false,
        IsReview: false,
      }));
    }
  }, [hasUnresolvedReviewComments, hasAllResolvedReviewComments]);

  useEffect(() => {
    setRmsReviewComments([]);
  }, [narrativeID]);

  const STATUS_COLORS = {
    approved: { solid: '#28a745', bg: '#eaf6ed', text: '#1a6b31', border: '#a3d9af' },
    'pending review': { solid: '#007bff', bg: '#e7f1ff', text: '#0056b3', border: '#99caff' },
    draft: { solid: '#ffc107', bg: '#fff9e6', text: '#856404', border: '#ffe08a' },
    reject: { solid: '#FF0000', bg: '#ffe6e6', text: '#cc0000', border: '#ffaaaa' },
    rejected: { solid: '#FF0000', bg: '#ffe6e6', text: '#cc0000', border: '#ffaaaa' },
  };

  const getStatusColor = (statuses) => {
    const last = statuses?.toLowerCase();
    return STATUS_COLORS[last] || STATUS_COLORS['draft'];
  };

  const getStatusBadgeStyle = (statuses) => {
    const c = getStatusColor(statuses);
    return { bg: c.bg, color: c.text, border: c.border };
  };

  const columns = [
    {
      name: "Action By Officer",
      selector: (row) => (row.actionBy ? row.actionBy : ""),
      sortable: true,
      sortFunction: (rowA, rowB) => compareStrings(rowA.actionBy, rowB.actionBy),
    },
    {
      name: "Written For Officer",
      selector: (row) => (row.WrittenFor_Officer ? row.WrittenFor_Officer : ""),
      sortable: true,
      sortFunction: (rowA, rowB) => compareStrings(rowA.WrittenFor_Officer, rowB.WrittenFor_Officer),
    },
    {
      name: 'Date/Time',
      selector: (row) => (row.Date ? getShowingDateText(row.Date) : ''),
      sortable: true,
      // cell: (row) => (row.Date ? getShowingDateText(row.Date) : ''),
      sortFunction: (rowA, rowB) => compareStrings(rowA.Date, rowB.Date),
    },
    {
      name: "Status",
      selector: (row) => (row.status ? <span style={{ backgroundColor: getStatusBadgeStyle(row.status).bg, color: getStatusBadgeStyle(row.status).color, fontSize: 10, fontWeight: 700, padding: '2px 4px', borderRadius: 3, border: `1px solid ${getStatusBadgeStyle(row.status).border}`, display: 'inline-block' }}>{row.IsRecall ? `${row.status} (Recall)` : row.status}</span> : ""),
      sortable: true,
      sortFunction: (rowA, rowB) => compareStrings(rowA.status, rowB.status),
    },
  ];

  useEffect(() => {
    if (loginAgencyID) {
      dispatch(get_Report_Approve_Officer_Data(loginAgencyID, loginPinID, narrativeID));
      if (narrativeTypeDrpData?.length === 0) { dispatch(get_Narrative_Type_Drp_Data(loginAgencyID)); }
      get_Group_List(loginAgencyID, loginPinID, narrativeID);
      if (useOfForceID) {
        GetData_ReportWorkLevelCheck_UseOfForce(loginAgencyID, useOfForceID);
      } else {
        GetData_ReportWorkLevelCheck(loginAgencyID, narrativeID);
      }
    }
  }, [loginAgencyID, useOfForceID]);

  useEffect(() => {
    if (!Array.isArray(groupList) || groupList.length === 0) {
      setGroupListWithFilter([]);
      return;
    }
    if (!Array.isArray(loginUserGroupList) || loginUserGroupList.length === 0) {
      setGroupListWithFilter([]);
      return;
    }
    const userLevels = loginUserGroupList
      .map((u) => Number(u.level ?? u.Level))
      .filter((n) => !Number.isNaN(n));
    const userTiersForMin = userLevels.filter((n) => n > 0);
    if (userTiersForMin.length === 0) {
      setGroupListWithFilter([]);
      return;
    }
    const userTopGroupLevel = Math.min(...userTiersForMin);
    const filtered = groupList.filter((item) => {
      const raw = item?.GroupLevel;
      if (raw == null || raw === '') return false;
      const gl = Number(raw);
      if (!Number.isFinite(gl) || gl <= 0) return false;
      return gl < userTopGroupLevel;
    });
    setGroupListWithFilter(filtered);
  }, [loginUserGroupList, groupList]);

  useEffect(() => {
    if (groupListWithFilter?.GroupID) {
      setValue({
        ...value,
        GroupName: changeArrayFormat_WithFilter(groupListWithFilter, 'group', groupListWithFilter[0]?.GroupID),
        IncidentId: incidentID, CreatedByUserFK: loginPinID,
      });
    }
  }, [groupListWithFilter]);

  useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = '.ck-powered-by { display: none !important; }';
    document.head.appendChild(style);
  }, []);

  const checkId = (id, obj) => {
    const status = obj?.filter((item) => item?.value == id);
    return status?.length > 0;
  };

  const checkWrittenId = async (id, obj) => {
    const status = await obj?.filter((item) => item?.value == id);
    return status?.length > 0;
  };

  useEffect(() => {
    if (editval) {
      setRmsReviewComments(parseAllComments(editval?.[0]?.AllComments));
      setIncidentNo(editval[0]?.IncidentNumber);
      setValue({
        ...value,
        IncidentID: editval[0]?.IncidentNumber,
        CADIncidentNumber: editval[0]?.RMSCaseNumber,
        ReportedBy_Description: editval[0]?.ReportedBy_Description,
        ReportName: editval[0]?.ReportName,
        sequence: editval[0]?.sequence,
        CommentsDoc: editval[0]?.CommentsDoc,
        UserCommentsDoc: editval[0]?.UserCommentsDoc || editval[0]?.LowerEditorCommentsDoc || '',
        Comments: editval[0]?.Comments,
        NarrativeReport_Comments: editval[0]?.NarrativeReport_Comments,
        WrittenID: editval[0]?.WrittenForID,
        IsReview: editval[0]?.IsReview,
      });
      setappRequiredCountCurrentStatus(editval[0]?.IsApprovedForwardCount);
      setApprovalStatus(editval[0]?.IsReview ? 'ApproveAndReview' : 'Approve');
      setIsSaved(false);
      if (editval[0]?.CommentsDoc?.trim()) {
        setEditorState(EditorState.createWithContent(ContentState.createFromBlockArray(htmlToDraft(editval[0]?.CommentsDoc ? editval[0].CommentsDoc?.trim() : '<p></p>'))));
      }
      setreviewStatus(editval[0]?.IsReview);
      setIncidentID(editval[0]?.IncidentID);
      setAsOfDate(editval[0]?.AsOfDate ? getShowingDateText(editval[0]?.AsOfDate) : '');
      setnarrativeTypeId(editval[0]?.NarrativeTypeID);
      setreportedPinActivity(editval[0]?.ReportedByPINActivityID);
      setIsDataReady(true);
    } else {
      setRmsReviewComments([]);
      setValue({
        ...value,
        IncidentID: '',
        CADIncidentNumber: '',
        ReportedBy_Description: '',
        Comments: '',
        sequence: '',
        CommentsDoc: '',
        UserCommentsDoc: '',
        WrittenID: '',
      });
    }
  }, [editval, parseAllComments]);

  useEffect(() => {
    const row = Array.isArray(editval) ? editval[0] : null;
    const activeIncidentID = row?.IncidentID || incidentID;
    if (!activeIncidentID) {
      setReportSummaryCards({
        isLoading: false,
        offenses: [],
        names: [],
        properties: [],
        vehicles: [],
        arrests: [],
      });
      return;
    }

    let cancelled = false;
    setReportSummaryCards((prev) => ({ ...prev, isLoading: true }));

    Promise.all([
      fetchPostDataNew('Incident/GetNamePropertyVehicleByIncidentID', { IncidentID: activeIncidentID }),
      fetchPostData('Crime/GetData_Offense', { IncidentId: activeIncidentID }),
      fetchPostData('Arrest/GetData_Arrest', { IncidentID: activeIncidentID, PINID: loginPinID }),
    ])
      .then(([tagApiRaw, offenseRaw, arrestRaw]) => {
        if (cancelled) return;
        const parsedTagApi = parseTablePayload(tagApiRaw);
        const tagNames = Array.isArray(parsedTagApi?.Table) ? parsedTagApi.Table : [];
        const tagProperties = Array.isArray(parsedTagApi?.Table1) ? parsedTagApi.Table1 : [];
        const tagVehicles = Array.isArray(parsedTagApi?.Table2) ? parsedTagApi.Table2 : [];
        const offenses = Array.isArray(offenseRaw) ? offenseRaw : [];
        const arrests = Array.isArray(arrestRaw) ? arrestRaw : [];

        setReportSummaryCards({
          isLoading: false,
          offenses,
          names: tagNames,
          properties: tagProperties,
          vehicles: tagVehicles,
          arrests,
        });
      })
      .catch(() => {
        if (cancelled) return;
        setReportSummaryCards({
          isLoading: false,
          offenses: [],
          names: [],
          properties: [],
          vehicles: [],
          arrests: [],
        });
      });

    return () => {
      cancelled = true;
    };
  }, [editval, incidentID, loginPinID, parseTablePayload]);

  // This function generates how much comments are open and resolved
  const reportSummaryMeta = useMemo(() => {
    const openComments = rmsReviewComments.filter((item) => String(item?.status || '').toLowerCase() !== 'resolved',).length;
    const resolvedComments = rmsReviewComments.filter((item) => String(item?.status || '').toLowerCase() === 'resolved',).length;
    const nibrsResolvedCountRaw = editval?.[0]?.nibrsReadinessResolvedCount ?? editval?.[0]?.NibrsReadinessResolvedCount;
    const nibrsTotalCountRaw = editval?.[0]?.nibrsReadinessTotalCount ?? editval?.[0]?.NibrsReadinessTotalCount;
    const nibrsResolvedCount = Number.parseInt(nibrsResolvedCountRaw, 10);
    const nibrsTotalCount = Number.parseInt(nibrsTotalCountRaw, 10);
    const safeResolvedCount = Number.isFinite(nibrsResolvedCount) && nibrsResolvedCount >= 0 ? nibrsResolvedCount : 0;
    const safeTotalCount = Number.isFinite(nibrsTotalCount) && nibrsTotalCount >= 0 ? nibrsTotalCount : 0;
    const tibrsPercent = calculateNibrsReadinessPercent(safeResolvedCount, safeTotalCount);

    return {
      openComments,
      resolvedComments,
      statusLabel: editval?.[0]?.Status || 'Pending review',
      tibrsStatus: `${tibrsPercent}%`,
      reviewGroup: selectedOption || 'Individual',
    };
  }, [rmsReviewComments, editval, selectedOption]);

  // This function generates the offense card items
  const offenseCardItems = useMemo(() => {
    return reportSummaryCards.offenses.map((offense, index) => {
      const offenseLabel = offense?.OffenseName_Description || 'Offense';
      const severity = offense?.AttemptComplete ? `<span style="${offense?.AttemptComplete === 'Completed' ? 'color: #19aea3; font-weight: bold;' : 'color: #f00; font-weight: bold;'}"> - ${offense.AttemptComplete}</span>` : '';
      const offenseCode = offense?.FBICode || '';
      return {
        key: offense?.CrimeID || offense?.OffenseID || `${offenseLabel}-${index}`,
        label: `<span style="font-weight: bold;">${offenseCode ? `${offenseCode} ` : ''}</span> | <span style="font-weight: normal;">${offenseLabel}${severity}</span>`,
      };
    });
  }, [reportSummaryCards.offenses]);

  // This function generates the name card items
  const nameCardItems = useMemo(() => {
    return reportSummaryCards.names.map((nameRow, index) => {
      const role = nameRow?.RoleName || 'Other';
      const roleTags = String(role)
        .split(',')
        .map((item) => item.trim())
        .filter(Boolean);
      return {
        key: nameRow?.NameID || nameRow?.MasterNameID || `${role}-${index}`,
        label: getNameCardLabel(nameRow),
        role,
        roleTags: roleTags.length ? roleTags : ['Other'],
      };
    });
  }, [reportSummaryCards.names, getNameCardLabel]);

  const shouldScrollOffenseList = offenseCardItems.length > 5;
  const shouldScrollNameList = nameCardItems.length > 5;

  const conditionalRowStyles = [
    {
      when: (row) => row === clickedRow,
      style: {
        backgroundColor: '#cce5ff',
        color: 'black',
      },
    },
  ];

  const tableCustomStyles = {
    headCells: {
      style: {
        fontWeight: 'bold',
        backgroundColor: '#00264d',
        color: '#ffffff',
      },
    },
  };

  useEffect(() => {
    const activeIncidentID = reviewIncidentID || incidentID;
    if (narrativeID && activeIncidentID) {
      get_Data_Narrative(narrativeID, activeIncidentID);
    }
  }, [narrativeID, reviewIncidentID, incidentID]);

  useEffect(() => {
    if (loginPinID && loginAgencyID) {
      GetPersonnelGroupDetails(loginPinID, loginAgencyID);
    }
  }, [loginPinID, loginAgencyID]);

  // api/SecurityGroupUserMembers/GetPersonnelGroupDetails
  const Add_Type = () => {
    const { IsApprove, IsReject, CommentsDoc, UserCommentsDoc } = value;
    const documentAccess = selectedOption === 'Individual' ? 'Individual' : 'Group';
    const val = {
      AgencyID: loginAgencyID,
      IncidentId: incidentID, NarrativeID: narrativeID, ApprovingSupervisorType: documentAccess, ApprovingSupervisorID: loginPinID, IsApprove: value.IsApprove === undefined && value.IsReject === undefined ? true : value.IsApprove, CreatedByUserFK: loginPinID, IsReject: IsApprove === undefined && IsReject === undefined ? false : IsReject,
      CommentsDoc,
      UserCommentsDoc,
      ReportedByPINActivityID: reportedPinActivity,
      NarrativeTypeID: narrativeTypeId, WrittenForID: value?.WrittenID,
      AllComments: JSON.stringify(rmsReviewComments),
      AsOfDate,
      ModifiedByUserFK: loginPinID,
      CaseID: caseID,
    };

    if (!useOfForceID) {
      AddDeleteUpadate('Narrative/Update_Narrative', val).then((res) => {
        Add_Type_Comments();
        get_Data_Narrative(narrativeID, reviewIncidentID || incidentID);
        const parseData = JSON.parse(res.data);
        toastifySuccess(parseData?.Table[0].Message);
        setIsSaved(true);
        setModelStatus(false);
        reset();
        navigate('/dashboard-page');
      });
    }
    if (useOfForceID) {
      Add_Type_Comments();
      get_Data_Narrative(narrativeID, reviewIncidentID || incidentID);
      setIsSaved(true);
      setModelStatus(false);
      reset();
      navigate('/dashboard-page');
    }
  };

  const Add_Type_Comments = () => {
    const { IsApprove, IsReject, ApprovalComments, ApprovingSupervisorID, IsApprovedForward, IsReview } = value;
    const type = selectedOption === 'Individual' ? 'Individual' : 'Group';
    const val = {
      AgencyID: loginAgencyID,
      IncidentId: incidentID, ApprovingSupervisorType: type, ApprovingSupervisorID: ApprovingSupervisorID,
      IsApprove: reviewStatus ? false : (value.IsApprove === undefined && value.IsReject === undefined) || IsApprovedForward ? true : value.IsApprove,
      CreatedByUserFK: loginPinID,
      IsApprovedForward: reviewStatus ? false : IsApprovedForward,
      IsReview: IsReview,
      IsReject: IsApprove === undefined && IsReject === undefined || reviewStatus ? false : IsReject,
      AllComments: JSON.stringify(rmsReviewComments),
      NarrativeID: useOfForceID ? '' : narrativeID,
      UseofForceID: useOfForceID,
      CaseID: caseID,
    };

    AddDeleteUpadate('IncidentNarrativeReport/Insert_IncidentNarrativeReport', val).then(() => {
      if (loginPinID && loginAgencyID) {
        get_Data_Que_Report(loginPinID, loginAgencyID);
      }
      resets();
    });
  };

  const reset = () => {
    setValue({
      ...value,
      CommentsDoc: '',
    });
  };

  const resets = () => {
    setValue({
      ...value,
      ApprovalComments: '',
    });
  };

  const handleRadioChange = (event) => {
    const selectedOptionnew = event.target.value;
    setApprovalStatus(selectedOptionnew);
    setValue((prevState) => ({
      ...prevState,
      IsApprove: selectedOptionnew === 'Approve',
      IsReject: selectedOptionnew === 'Reject',
      IsApprovedForward: selectedOptionnew === 'ApproveAndForward',
      IsReview: selectedOptionnew === 'ApproveAndReview',
      ApprovalComments: '',
    }));

    setErrors({ ...errors, ApprovalCommentsError: '', CommentsDocumentsError: '', ApprovingOfficerError: '', GroupError: '' });
  };

  const handleChange = (event) => {
    const { name, value: inputValue } = event.target;
    if (event) {
      setValue((prevState) => ({ ...prevState, [name]: inputValue }));
    } else {
      setValue((prevState) => ({ ...prevState, [name]: null }));
    }
  };

  const check_Validation_ErrorApproval = () => {
    Add_Type();
  };

  const { ApprovalCommentsError, CommentsDocumentsError, ApprovingOfficerError } = errors;

  useEffect(() => {
    if (useOfForceID) {
      if (value.IsApprovedForward || value.IsReview) {
        if (ApprovalCommentsError === 'true' && ApprovingOfficerError === 'true') {
          Add_Type();
          resetserror();
        }
      } else if (ApprovalCommentsError === 'true') {
        Add_Type();
        resetserror();
      }
    } else if (value.IsApprovedForward || value.IsReview) {
      if (ApprovalCommentsError === 'true' && CommentsDocumentsError === 'true' && ApprovingOfficerError === 'true') {
        Add_Type();
        resetserror();
      }
    } else if (ApprovalCommentsError === 'true' && CommentsDocumentsError === 'true') {
      Add_Type();
      resetserror();
    }
  }, [ApprovalCommentsError, CommentsDocumentsError, ApprovingOfficerError]);

  const resetserror = () => {
    setErrors({ ...errors, ApprovalCommentsError: '', CommentsDocumentsError: '', ApprovingOfficerError: '', GroupError: '' });
  };

  const handleRadioChangeArrestForward = (e) => {
    const selectedValue = e.target.value;
    setSelectedOption(selectedValue);
    setMultiSelected({ optionSelected: [] });
    setErrors({ ...errors, ApprovalCommentsError: '', CommentsDocumentsError: '', ApprovingOfficerError: '', GroupError: '' });
  };

  const Agencychange = (nextSelected) => {
    setMultiSelected({ optionSelected: nextSelected });
    const id = [];
    if (nextSelected) {
      nextSelected.forEach((item) => { id.push(item.value); });
      setValue({ ...value, ApprovingSupervisorID: id.toString() });
    }
  };

  const colourStylesUsers = {
    control: (styles, { isDisabled }) => ({
      ...styles,
      backgroundColor: isDisabled ? '#d3d3d3' : '#ffe2a8',
      fontSize: 14,
      marginTop: 2,
      boxShadow: 'none',
      cursor: isDisabled ? 'not-allowed' : 'default',
    }),
    menu: (provided) => ({
      ...provided,
      maxHeight: '120px',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '120px',
      overflowY: 'auto',
    }),
  };

  if (!isDataReady) {
    return (
      <div className="custom-modal-wrapper d-flex justify-content-center align-items-center">
        <div className="spinner-border text-primary" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="modal fade show d-block" style={{ background: 'rgba(0,0,0,0.5)' }}>
      <style>
        {`
          .report-review-rms-editor .rms-comment-editor-wrap .ql-container {
            height: var(--review-editor-max-height, 24vh) !important;
            max-height: var(--review-editor-max-height, 24vh);
            overflow-y: auto !important;
            overflow-x: hidden !important;
          }
          .report-review-rms-editor .rms-comment-editor-wrap .ql-editor {
            height: auto !important;
            max-height: none !important;
            min-height: 100%;
            overflow: visible !important;
          }
          .report-review-rms-editor .rms-comment-editor-wrap {
            padding-bottom: 14px;
          }
          .report-review-rms-editor .rms-comment-readonly-badge {
            margin-top: 8px;
            margin-bottom: 0;
          }
          .report-review-rms-editor .rms-comment-sidebar {
            height: calc(var(--review-editor-max-height, 24vh) + 42px);
            max-height: calc(var(--review-editor-max-height, 24vh) + 42px);
            overflow-y: auto;
          }
          .report-review-generated-editor .ql-toolbar.ql-snow,
          .report-review-generated-editor .ql-container.ql-snow,
          .report-review-generated-editor .ql-editor {
            background-color: #eceff3 !important;
          }
          .report-review-generated-editor .ql-editor [style*="background"] {
            background-color: transparent !important;
          }
          .report-review-rms-editor .report-review .ql-container.ql-snow,
          .report-review-rms-editor .report-review .ql-editor {
            background-color: #ffe2a8 !important;
          }
          .report-review-readonly-editor .ql-disabled {
            border: none !important;
          }
          .report-review-summary-meta-card {
            border: 1px solid #d6e4f2;
            background: #ffffff;
            border-radius: 10px;
            padding: 10px 10px;
            box-shadow: 0 1px 6px rgba(16, 24, 40, 0.06);
            margin-bottom: 12px;
          }
          .report-review-summary-meta-row {
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 12px;
            padding: 4px 0;
          }
          .report-review-summary-meta-row + .report-review-summary-meta-row {
            border-top: 1px solid #edf2f9;
          }
          .report-review-summary-meta-label {
            color: #5e6f82;
            font-size: 10px;
            text-transform: uppercase;
            letter-spacing: 0.55px;
            font-weight: 700;
            line-height: 1.2;
          }
          .report-review-summary-meta-value {
            color: #0f2745;
            font-size: 12px;
            font-weight: 600;
            line-height: 1.35;
            text-align: right;
          }
          .report-review-summary-grid {
            display: grid;
            grid-template-columns: 1fr;
            gap: 10px;
          }
          .report-review-summary-card {
            border: 1px solid #d9e3f0;
            border-radius: 10px;
            padding: 10px;
            background: #ffffff;
            box-shadow: 0 2px 10px rgba(16, 24, 40, 0.05);
          }
          .report-review-summary-card-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 4px;
          }
          .report-review-summary-title {
            font-size: 10px;
            font-weight: 700;
            color: #0f2745;
            letter-spacing: 0.45px;
          }
          .report-review-summary-count {
            min-width: 20px;
            height: 18px;
            border-radius: 999px;
            background: linear-gradient(135deg, #0f4ea1 0%, #0a3672 100%);
            color: #ffffff;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            font-size: 11px;
            font-weight: 600;
            padding: 0 6px;
          }
          .report-review-summary-row {
            border-top: 1px solid #edf2f9;
            padding: 8px 0;
            font-size: 11px;
            color: #1d2939;
          }
          .report-review-summary-empty {
            padding-top: 8px;
            font-size: 12px;
            color: #8b99ab;
          }
          .report-review-name-row {
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 10px;
          }
          .report-review-name-label {
            font-size: 12px;
            color: #1d2939;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            max-width: 62%;
          }
          .report-review-role-chip-wrap {
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-end;
            gap: 6px;
          }
          .report-review-role-chip {
            font-size: 10px;
            color: #0f4ea1;
            border: 1px solid #c8dcff;
            background: #eef5ff;
            border-radius: 999px;
            padding: 3px 8px;
            line-height: 1.2;
            font-weight: 700;
            white-space: nowrap;
          }
          .report-review-entities-grid {
            display: grid;
            grid-template-columns: repeat(2, minmax(0, 1fr));
            gap: 8px;
          }
          .report-review-entity-card {
            border: 1px solid #dbe6f2;
            border-radius: 10px;
            padding: 10px 6px;
            text-align: center;
            background: linear-gradient(180deg, #f9fbff 0%, #f2f6fd 100%);
          }
          .report-review-entity-value {
            font-size: 15px;
            font-weight: 700;
            color: #0f2745;
            line-height: 1.1;
          }
          .report-review-entity-label {
            font-size: 10px;
            font-weight: 600;
            color: #52657d;
            letter-spacing: 0.45px;
            margin-top: 4px;
          }
          .report-review-main-layout {
            display: grid;
            grid-template-columns: minmax(150px, 0.5fr) minmax(0, 1.8fr);
            gap: 14px;
            align-items: start;
          }
          .report-review-top-meta-row {
            display: flex;
            flex-wrap: nowrap;
            gap: 8px;
            margin-top: 4px;
            margin-bottom: 10px;
            overflow-x: auto;
            padding-bottom: 2px;
          }
          .report-review-top-meta-item {
            min-width: 180px;
            flex: 1 0 180px;
          }
          .report-review-top-meta-item .label-name {
            float: none !important;
            margin-bottom: 2px;
            display: block;
          }
          .report-review-top-meta-item input {
            height: 34px;
          }
          .report-review-approval-inline {
            display: flex;
            align-items: center;
            gap: 20px;
            padding: 4px 0 6px 2px;
          }
          .report-review-approval-inline .form-check {
            margin-bottom: 0;
          }
          .report-review-summary-panel,
          .report-review-content-panel {
            background: #ffffff;
          }
          .report-review-summary-scroll {
            overflow: visible;
            padding-right: 0;
            max-height: none;
          }
          .report-review-summary-list {
            display: block;
          }
          .report-review-summary-list--scrollable {
            max-height: 190px;
            overflow-y: auto;
            overflow-x: hidden;
            padding-right: 2px;
          }
          @media (max-width: 1200px) {
            .report-review-summary-grid {
              grid-template-columns: minmax(0, 1fr);
            }
            .report-review-name-label {
              max-width: 54%;
            }
            .report-review-main-layout {
              grid-template-columns: minmax(0, 1fr);
            }
            .report-review-top-meta-row {
              flex-wrap: wrap;
            }
          }
        `}
      </style>
      <div className={`modal-dialog ${isFullScreen ? 'modal-fullscreen' : 'modal-xl'} modal-dialog-centered`}>
        <div className="modal-content p-2 px-4 approvedReportsModal" style={{ minHeight: useOfForceID ? '280px' : '500px', maxHeight: 'calc(100vh - 90px)', overflow: 'hidden' }}>
          <div className="d-flex justify-content-between p-2">
            <div className="row mt-1 mb-2">
              <div className="col-12">
                <nav className="nav nav-tabs">
                  <span className={`nav-link nav-links mr-2 ${activeTab === 'ReportReview' ? 'active' : ''}`} style={{ color: activeTab === 'ReportReview' ? 'blue' : 'Red' }} aria-current="page" onClick={() => setActiveTab('ReportReview')}>
                    Report Review
                  </span>
                  |
                  <span className={`nav-link nav-links ml-2 ${activeTab === 'History' ? 'active' : ''}`} style={{ color: activeTab === 'History' ? 'blue' : 'Red' }} aria-current="page" onClick={() => setActiveTab('History')}>
                    History
                  </span>
                </nav>
              </div>
            </div>
            <div className="d-flex justify-content-end">
              <button type="button" className="btn btn-sm btn-outline-secondary mr-2" onClick={() => setIsFullScreen((prev) => !prev)}>
                {isFullScreen ? (<><i className="fa fa-compress"></i> Normal</>) : (<><i className="fa fa-expand"></i> Full Screen</>)}
              </button>
              <button className="btn-close b-none bg-transparent" onClick={() => { setActiveTab('ReportReview'); setModelStatus(false); resetserror(); }} data-dismiss="modal">X</button>
            </div>
          </div>
          <div style={{ maxHeight: 'calc(100vh - 165px)', overflowY: 'auto', overflowX: 'hidden', paddingRight: '4px' }}>
            {activeTab === 'History' && (
              <div className="mb-3 mt-4">
                <DataTable
                  data={Array.isArray(filteredData) ? filteredData : []}
                  columns={columns}
                  keyField="historyRowId"
                  dense
                  highlightOnHover
                  noHeader
                  customStyles={tableCustomStyles}
                  conditionalRowStyles={conditionalRowStyles}
                  onRowClicked={setClickedRow}
                  paginationPerPage={10}
                  paginationRowsPerPageOptions={[10, 25, 50, 100]}
                  pagination
                />
              </div>
            )}

            {activeTab === 'ReportReview' && (
              <>
                {!useOfForceID && (
                  <>
                    <div className="row mt-1">
                      {[
                        { className: 'col-12 col-md-4 col-lg-2 mb-2', value: value?.IncidentID, label: 'Incident #' },
                        { className: 'col-12 col-md-4 col-lg-2 mb-2', value: value?.CADIncidentNumber, label: 'Case #' },
                        { className: 'col-12 col-md-4 col-lg-2 mb-2', value: value?.ReportedBy_Description, label: 'Submitting Officer' },
                        { className: 'col-12 col-md-4 col-lg-2 mb-2', value: value?.ReportName || editval?.[0]?.NarrativeDescription || '', label: 'Report Type' },
                        { className: 'col-12 col-md-4 col-lg-2 mb-2', value: AsOfDate || (editval?.[0]?.IncidentReportedDateTime ? getShowingDateText(editval[0].IncidentReportedDateTime) : '') || (editval?.[0]?.CreatedDtTm ? getShowingDateText(editval[0].CreatedDtTm) : ''), label: 'Incident Date/Time' },
                      ].map((item, index) => (
                        <div className={item.className} key={index}>
                          <label className="label-name" style={{ float: 'left' }}>{item.label}</label>
                          <input type="text" className="form-control" value={item.value || ''} readOnly />
                        </div>
                      ))}

                      {editval?.[0]?.NarrativeDescription === 'Supplementary Narrative' && (
                        <div className="col-12 col-md-4 col-lg-2 mb-2">
                          <label className="label-name" style={{ float: 'left' }}>Seq #</label>
                          <input type="text" className="form-control" value={value?.sequence || ''} readOnly />
                        </div>
                      )}
                    </div>

                    <div className="report-review-main-layout mt-1">
                      <div className="report-review-summary-panel" style={{ overflow: 'hidden' }}>
                        <div style={{ paddingBottom: '8px', borderBottom: '1px solid #e2e2e2', fontSize: '12px', fontWeight: 700, color: '#6c757d', letterSpacing: '0.5px' }}>
                          REPORT SUMMARY
                        </div>
                        <div className="py-2 report-review-summary-scroll" style={{ '--summary-scroll-max-height': isFullScreen ? '78vh' : '66vh' }}>
                          {reportSummaryCards.isLoading ? (
                            <div className="d-flex align-items-center justify-content-center h-100 text-muted" style={{ minHeight: '180px' }}>
                              <i className="fa fa-spinner fa-spin mr-2"></i> Loading report summary...
                            </div>
                          ) : (
                            <div className="report-review-summary-shell">
                              <div className="report-review-summary-meta-card">
                                {[
                                  { label: 'Status', value: reportSummaryMeta.statusLabel },
                                  { label: 'TIBRS', value: reportSummaryMeta.tibrsStatus },
                                  { label: 'Group', value: reportSummaryMeta.reviewGroup },
                                  { label: 'Comments', value: `${reportSummaryMeta.openComments} open  |  ${reportSummaryMeta.resolvedComments} resolved` },
                                ].map((meta) => (
                                  <div key={meta.label} className="report-review-summary-meta-row">
                                    <div className="report-review-summary-meta-label">{meta.label}</div>
                                    <div className="report-review-summary-meta-value">{meta.value || '-'}</div>
                                  </div>
                                ))}
                              </div>

                              <div className="report-review-summary-grid">
                                <div className="report-review-summary-card">
                                  <div className="report-review-summary-card-header">
                                    <div className="report-review-summary-title">OFFENSES</div>
                                    <span className="report-review-summary-count">{reportSummaryCards.offenses.length}</span>
                                  </div>
                                  {offenseCardItems.length > 0 ? (
                                    <div className={`report-review-summary-list ${shouldScrollOffenseList ? 'report-review-summary-list--scrollable' : ''}`}>
                                      {offenseCardItems.map((item) => (
                                        <div key={item.key} className="report-review-summary-row">
                                          <span dangerouslySetInnerHTML={{ __html: item.label }} />
                                        </div>
                                      ))}
                                    </div>
                                  ) : (
                                    <div className="report-review-summary-empty">No offenses linked to this incident.</div>
                                  )}
                                </div>

                                <div className="report-review-summary-card">
                                  <div className="report-review-summary-card-header">
                                    <div className="report-review-summary-title">NAMES</div>
                                    <span className="report-review-summary-count">{reportSummaryCards.names.length}</span>
                                  </div>
                                  {nameCardItems.length > 0 ? (
                                    <div className={`report-review-summary-list ${shouldScrollNameList ? 'report-review-summary-list--scrollable' : ''}`}>
                                      {nameCardItems.map((item) => (
                                        <div key={item.key} className="report-review-summary-row report-review-name-row">
                                          <span className="report-review-name-label">{item.label}</span>
                                          <span className="report-review-role-chip-wrap">
                                            {item.roleTags.map((roleTag) => (
                                              <span key={`${item.key}-${roleTag}`} className="report-review-role-chip">
                                                {roleTag}
                                              </span>
                                            ))}
                                          </span>
                                        </div>
                                      ))}
                                    </div>
                                  ) : (
                                    <div className="report-review-summary-empty">No names linked to this incident.</div>
                                  )}
                                </div>

                                <div className="report-review-summary-card">
                                  <div className="report-review-summary-card-header">
                                    <div className="report-review-summary-title">OTHER ENTITIES</div>
                                  </div>
                                  <div className="report-review-entities-grid">
                                    {[
                                      { label: 'NAME', value: reportSummaryCards.names.length },
                                      { label: 'PROPERTY', value: reportSummaryCards.properties.length },
                                      { label: 'VEHICLE', value: reportSummaryCards.vehicles.length },
                                      { label: 'ARREST', value: reportSummaryCards.arrests.length },
                                    ].map((entity) => (
                                      <div key={entity.label} className="report-review-entity-card">
                                        <div className="report-review-entity-value">{entity.value}</div>
                                        <div className="report-review-entity-label">{entity.label}</div>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="report-review-content-panel">
                        <div style={{ overflow: 'visible', position: 'relative', zIndex: 2 }}>
                          <div style={{ paddingBottom: '8px', borderBottom: '1px solid #e2e2e2', fontSize: '12px', fontWeight: 700, color: '#6c757d', letterSpacing: '0.5px' }}>
                            GENERATED REPORT
                          </div>
                          <div className="py-2">
                            <div style={{ border: '1px solid #cfd6dd', borderRadius: '4px', backgroundColor: '#fff', overflow: 'hidden' }}>
                              <ReactQuill
                                className="editor-class report-review-readonly-editor"
                                value={generatedNarrativeContent}
                                readOnly={true}
                                modules={{ toolbar: false }}
                                theme="snow"
                                style={{ height: isFullScreen ? '40vh' : '35vh', padding: '0' }}
                              />
                            </div>
                          </div>
                        </div>
                        <div style={{ overflow: 'hidden' }}>
                          {/* <div style={{ padding: '8px 0px', borderBottom: '1px solid #e2e2e2', fontSize: '12px', fontWeight: 700, color: '#6c757d', letterSpacing: '0.5px' }}>
                            OFFICER NARATIVE
                          </div> */}
                          <div className="p-0 report-review-rms-editor" style={{ '--review-editor-max-height': isFullScreen ? '36vh' : '30vh', position: 'relative', overflow: 'hidden', zIndex: 3 }}>
                            <RMSCommentEditor
                              key={`officer-${narrativeID || editval?.[0]?.NarrativeID || 'report-review'}`}
                              currentUser={reviewCommentUser}
                              reportId={String(narrativeID || editval?.[0]?.NarrativeID || '')}
                              initialContent={officerNarrativeContent}
                              initialComments={rmsReviewComments}
                              onContentChange={(content) => {
                                setValue((prevState) => ({
                                  ...prevState,
                                  UserCommentsDoc: content ?? '',
                                }));
                              }}
                              contentReadOnly={true}
                              actionMode="reportReview"
                              onSave={handleRmsCommentSave}
                              className="report-review"
                            />
                          </div>

                          {(reviewStatus === false || reviewStatus === 'false') && (
                            <div className="report-review-approval-inline">
                              <div className="form-check">
                                <input className="form-check-input" type="radio" value="Approve" name="flexRadioDefault" checked={value.IsApprove} onChange={handleRadioChange} disabled={hasUnresolvedReviewComments} />
                                <label className="form-check-label">Approve</label>
                              </div>
                              <div className="form-check">
                                <input className="form-check-input" type="radio" value="Reject" name="flexRadioDefault" checked={value.IsReject} onChange={handleRadioChange} disabled={hasAllResolvedReviewComments} />
                                <label className="form-check-label">Reject</label>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </>
                )}

                {useOfForceID && (
                  <div className="row mt-1">
                    {[
                      { className: 'col-12 col-md-4 col-lg-2 mb-2', value: value?.IncidentID, label: 'Incident #' },
                      { className: 'col-12 col-md-4 col-lg-2 mb-2', value: value?.CADIncidentNumber, label: 'Case #' },
                      { className: 'col-12 col-md-4 col-lg-2 mb-2', value: value?.ReportedBy_Description, label: 'Submitting Officer' },
                      { className: 'col-12 col-md-4 col-lg-2 mb-2', value: value?.ReportName || editval?.[0]?.NarrativeDescription || '', label: 'Report Type' },
                      { className: 'col-12 col-md-4 col-lg-2 mb-2', value: AsOfDate || (editval?.[0]?.IncidentReportedDateTime ? getShowingDateText(editval[0].IncidentReportedDateTime) : '') || (editval?.[0]?.CreatedDtTm ? getShowingDateText(editval[0].CreatedDtTm) : ''), label: 'Incident Date/Time' },
                    ].map((item, index) => (
                      <div className={item.className} key={index}>
                        <label className="label-name" style={{ float: 'left' }}>{item.label}</label>
                        <input type="text" className="form-control" value={item.value || ''} readOnly />
                      </div>
                    ))}

                    {editval?.[0]?.NarrativeDescription === 'Supplementary Narrative' && (
                      <div className="col-12 col-md-4 col-lg-2 mb-2">
                        <label className="label-name" style={{ float: 'left' }}>Seq #</label>
                        <input type="text" className="form-control" value={value?.sequence || ''} readOnly />
                      </div>
                    )}
                  </div>
                )}

                {useOfForceID && (
                  <div className="row mt-3">
                    {(reviewStatus === false || reviewStatus === 'false') && (
                      <>
                        <div className="col-md-2">
                          <div className="form-check">
                            <input className="form-check-input" type="radio" value="Approve" name="flexRadioDefault" checked={value.IsApprove} onChange={handleRadioChange} disabled={hasUnresolvedReviewComments} />
                            <label className="form-check-label">Approve</label>
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="form-check">
                            <input className="form-check-input" type="radio" value="Reject" name="flexRadioDefault" checked={value.IsReject} onChange={handleRadioChange} disabled={hasAllResolvedReviewComments} />
                            <label className="form-check-label">Reject</label>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                )}

                <div className="d-flex justify-content-end mt-4">
                  {!isSaved && (
                    <button className="btn btn-primary" disabled={editval[0]?.IsReview} style={{ backgroundColor: '#001f3f', color: '#fff' }} onClick={() => { check_Validation_ErrorApproval(); }}>Save</button>
                  )}
                  <button
                    type="button"
                    className="btn btn-sm btn-success ml-2"
                    {...(!useOfForceID && !arrestID && {
                      'data-toggle': 'modal',
                      'data-target': '#CurrentIncidentReport',
                    })}
                    onClick={() => {
                      if (arrestID) {
                        setTriggerArrestPrintCount((c) => c + 1);
                      } else if (useOfForceID) {
                        setTriggerUseOfForcePrintCount((c) => c + 1);
                      } else {
                        setShowModal(true);
                        setIncMasterReport(true);
                        setIncReportCount(IncReportCount + 1);
                      }
                    }}
                  >
                    Print <i className="fa fa-print"></i>
                  </button>
                </div>
              </>
            )}
          </div>

          <CurrentIncMasterReport
            incNumber={IncidentNo}
            {...{
              printIncReport,
              setIncMasterReport,
              showModal,
              setShowModal,
              IncReportCount,
              setIncReportCount,
            }}
          />

          {!!(useOfForceID && !arrestID) ? (
            <div style={{ display: 'none' }}>
              <PoliceForceIncident triggerPrintCount={triggerUseOfForcePrintCount} externalIncidentID={editval[0]?.IncidentID} externalUseOfForceID={useOfForceID} />
            </div>
          ) : null}

          {!!arrestID ? (
            <div style={{ display: 'none' }}>
              <PoliceForce triggerPrintCount={triggerArrestPrintCount} externalArrestID={arrestID} externalIncidentID={editval[0]?.IncidentID} />
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default PendingReportReviewModal;
